import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonType, ShareReferral } from '../../../shared';

import classes from './ReferralInvite.module.scss';

export const ReferralInvite: FunctionComponent = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={classes['referral-invite']}>
      <h2 className={classes['referral-invite__title']}>{t('referralInvite.title')}</h2>

      <div className={classes['referral-invite__text']}>{t('referralInvite.text')}</div>

      <Button
        type={ButtonType.primary}
        label={t('referralInvite.button')}
        onClick={() => setIsOpen(true)}
        fullWidth
      />

      <ShareReferral isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};
